import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export default {
  methods: {
    durationFromNow(date, withoutSuffix = false) {
      return dayjs(date).fromNow(withoutSuffix);
    },

    formatDate(date, format) {
      return dayjs(date).format(format);
    },

    isPastDate(date) {
      return dayjs().isAfter(dayjs(date));
    },
  },
};
